import React from 'react';
import './style.scss';
import { Image, Link, Text } from '@sitecore-jss/sitecore-jss-react';
import { dateFormat } from '../../../Shared/Helpers/dateTimeHelper';

const DocumentCards = ({ items, t, lang }) => {
  if (!(items?.length > 0)) return null;

  return (
    <div className="document-component-cards">
      {items.map((item) => (
        <DocumentCard data={item} key={item.id} t={t} lang={lang} />
      ))}
    </div>
  );
};

const DocumentCard = ({ data, t, lang }) => {
  const { hyperLink, title, size, type, lastUpdated } = data.fields;

  const needSize = !!size?.value;
  const needType = !!type?.fields?.DropdownText;
  const needLast = !!lastUpdated?.value && !lastUpdated?.value?.startsWith('0001');

  let formattedDateRes = { value: '' };
  if (needLast) {
    const formattedDate = dateFormat(lastUpdated?.value, lang);
    formattedDateRes = {
      value: `${formattedDate?.day}/${formattedDate?.monthNumber}/${formattedDate?.year}`,
    };
  }

  return (
    <Link field={hyperLink} className="dc-cards-card">
      <div className="dc-cards-card-icon-wrapper">
        <Image field={type?.fields?.image} className="dc-cards-card-icon" />
        <Image field={type?.fields?.image2} className="dc-cards-card-sub-icon" />
      </div>
      <div className="dc-cards-card-desc">
        <div className="dc-cards-cd-title">
          <Text field={title} />
        </div>
        {(needType || needSize) && (
          <div className="dc-cards-cd-info">
            {needSize && <Text field={size} />}
            {needSize && needType && '/'}
            {needType && <Text field={type.fields.DropdownText} />}
          </div>
        )}
        {needLast && (
          <div className="dc-cards-cd-updated-at">
            {t('Last updated')} <Text field={formattedDateRes} />
          </div>
        )}
      </div>
    </Link>
  );
};

export default DocumentCards;
